<template>
  <div class="list-box">
    <div
      style="
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        justify-content: flex-end;
      "
    >
      <text style="color: #a2a2a2">月份：</text>
      <el-date-picker
        v-model="state.skssq"
        type="month"
        placeholder="税款所属月份"
        value-format="YYYYMM"
        format="YYYY年M月"
        :clearable="false"
        style="width: 160px; margin-right: 10px"
      />
      <el-button type="primary" @click="onSubmit">提交更新申请</el-button>
      <el-button type="info" @click="onClose">取消</el-button>
    </div>
    <ul class="list-search">
      <el-space wrap style="flex: 1">
        <el-input
          v-model="state.params.keywords"
          style="width: 200px"
          placeholder="名称、统一社会信用代码"
          clearable
          @clear="
            delete state.params.keywords;
            onLoad();
          "
          @paste.enter="$onKeywordsPaste($event, state.params)"
        ></el-input>
        <el-select
          v-model="state.params.tax_bureau_id"
          @clear="delete state.params.tax_bureau_id"
          style="width: 200px"
          placeholder="所属税局"
        >
          <el-option
            v-for="item in state.taxbureau_data"
            :key="item"
            :label="item.name"
            :value="item.id"
          />
          <template #footer>
            <el-button size="small" @click="onLoadTaxBureauData()">
              刷新
            </el-button>
          </template>
        </el-select>
        <el-dropdown split-button @click="onLoad" type="primary">
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-space>
    </ul>
    <ul class="list-table">
      <el-table
        ref="tableDom"
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
        @row-click="onRowClick"
      >
        <el-table-column type="selection" width="55" fixed />
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column
          prop="name"
          label="名称"
          show-overflow-tooltip
          :formatter="
            (row, column, cellValue) =>
              $tab_Highlinght(cellValue, state.params.keywords)
          "
        />
        <el-table-column
          prop="unified_social_credit_identifier"
          label="统一社会信用代码"
          show-overflow-tooltip
          :formatter="
            (row, column, cellValue) =>
              $tab_Highlinght(cellValue, state.params.keywords)
          "
        />
        <el-table-column
          prop="tax_bureau_name"
          label="所属税局"
          show-overflow-tooltip
          :formatter="$tab_TextFormat"
        />
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { data_taxbureau_select } from "@/http/data";
import { data_withholdingagent_page } from "@/http/data";
import { personalpension_pull } from "@/http/personalpension";
import { ElMessage, ElMessageBox, dayjs } from "element-plus";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
  };
}
export default {
  props: {
    skssq: String,
  },
  setup(props, { emit }) {
    const tableDom = ref(null);
    const state = reactive(new InitFormData());
    onMounted(() => {
      state.skssq = props.skssq;

      onLoad();
      onLoadTaxBureauData();
    });

    const onLoad = () => {
      delete state.tableData;
      data_withholdingagent_page(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //获取税局
    const onLoadTaxBureauData = () => {
      data_taxbureau_select().then((res) => {
        if (res.status == 200) state.taxbureau_data = res.data.data?.list;
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    //表格行点击事件
    const onRowClick = (row) => {
      tableDom.value.toggleRowSelection(row);
    };

    const onClose = () => {
      emit("Close");
    };

    const onSubmit = () => {
      const rows = tableDom.value.getSelectionRows();
      if (rows.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择扣缴义务人",
          grouping: true,
        });
        return false;
      }

      if (!state.skssq) {
        ElMessage({
          type: "warning",
          message: "请选择要更新的月份",
          grouping: true,
        });
        return false;
      }

      ElMessageBox.confirm(
        `您确定更新已选<strong style='color:#1e90ff'>${
          rows.length
        }条</strong>扣缴义务人下所有员工<strong style='color:#ffa500'>${dayjs(
          state.skssq,
        ).format("YYYY年M月")}</strong>的个人养老金数据吗？`,
        "更新确认",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定更新",
          cancelButtonText: "取消",
          type: "warning",
        },
      ).then(() => {
        const data = {
          withholding_agent_id: rows.map((m) => m.id).join(","),
          skssq: state.skssq,
        };
        personalpension_pull(data).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            emit("Comfirm");
          }
        });
      });
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
      onLoadTaxBureauData,
      onRowClick,
      props,
      tableDom,
      onClose,
      onSubmit,
    };
  },
};
</script>
<style scoped></style>
